module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows@3x-b7416b6400b6d7a322b60fe3517bd5cf.png";